import { Box, TableCell } from "@mui/material";
import { styled } from "@mui/system";

export const WorkTitleTableCell = styled(TableCell, {
  shouldForwardProp: (prop) => prop !== "isOpen",
})(({ isOpen }: { isOpen: boolean }) => ({
  borderBottom: isOpen ? "1px solid rgba(224, 224, 224, 1)" : "none",
  padding: "0.5rem 0.5rem 0.5rem 0",
  fontSize: "14px",
  fontWeight: 400,
}));

export const WorkTitleContainer = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.5rem",
}));

export const WorkHistoriesCount = styled(Box)(() => ({
  width: "28px",
  height: "24px",
  backgroundColor: "rgba(0, 8, 40, 0.08)",
  borderRadius: "16px",
  textAlign: "center",
  fontWeight: 600,
  display: "grid",
  alignContent: "center",
}));
